import React, { useEffect, useState } from 'react';
import {
  tableHeader,
  graphLeft,
  graphCenter,
  graphRight,
  graphLeft_sm,
  graphCenter_sm,
  graphRight_sm,
  graphLeft_base,
  graphCenter_base,
  graphRight_base,
  bodyCellPercentage,
  bodyCellTotal,
  bodyCellPara,
  rejectedGp,
  rejectBg,
  showGpBorderBottom,
  showGpBorderTop
} from './FunnelReport.module.css';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../data/SiteConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, fal } from '@fortawesome/pro-light-svg-icons';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import DateFilter from '../PopupFilter/FilterComponents/DateFilter';
import RM from '../PopupFilter/FilterComponents/RmList';
import Source from '../PopupFilter/FilterComponents/Source';
import Zone from '../PopupFilter/FilterComponents/ZoneList';
import NewSpinner from '../NewSpinner/NewSpinner';

import PublicIcon from '@material-ui/icons/Public';
import rmICon from '../../../images/icons/PopUpFilter/rmImg.svg';
import PopupFilter from '../PopupFilter/PopupFilter';
import FilterListIcon from '@material-ui/icons/FilterList';
import SvgComponent from '../SvgComponent/SvgComponent';
import DetailsIcon from '@material-ui/icons/Details';
import { getFunnelReport } from '../../../common/constants/api';
import moment from 'moment';
import {
  getFiltersInfo,
  setFiltersInfo
} from '../../../../../lems-ui/src/common/utils/FiltersInfo';
import numberFormat from '../../../common/constants/NumberFormat';

const FunnelReport = () => {
  const [maxVal, setMaxVal] = useState(90 / 100);

  const [showFilter, setShowFilter] = useState(false);
  const [shoHtmlSelectedFileds, setHtmlSelectedFileds] = useState('');
  const [masterFilters, setMasterFilters] = useState(
    getFiltersInfo()?.funnelReport || {}
  );
  const [funnelData, setFunnelData] = useState({});
  const [isInProgress, setIsInProgress] = useState(false);

  const bodyCell = 'font-roboto font-medium  text-sm text-black-500  py-2';
  const graphCell = 'py-1';
  const colors = [
    '#FAB1A0',
    '#FBA6A2',
    '#FB9BA3',
    '#FC8FA5',
    '#FC84A6',
    '#FD79A8',
    '#EE7FB6',
    '#DF84C5',
    '#D08AD3',
    '#C090E1',
    '#B195F0',
    '#A29BFE',
    '#8997FA',
    '#6F93F5',
    '#5690F1',
    '#3C8CEC',
    '#2388E8',
    '#0984E3'
  ];

  const getFunnelData = ({
    fromDateOverider = null,
    toDateOverrider = null,
    cityOverrider = null,
    sourceOverrider = null,
    rmOverrider = null
  }) => {
    setIsInProgress(true);
    getFunnelReport({
      from: fromDateOverider || moment().format('YYYY-MM-DD'),
      to: toDateOverrider || moment().format('YYYY-MM-DD'),
      rm: rmOverrider,
      source: sourceOverrider,
      city: cityOverrider
    })
      .then(res => {
        setIsInProgress(false);
        setFunnelData(res);
      })
      .catch(error => {
        setIsInProgress(false);
      });
  };
  useEffect(() => {
    getFunnelData({});
  }, []);

  const appledFilters = e => {
    setFiltersInfo({
      ...(getFiltersInfo() || {}),
      funnelReport: e
    });
    let startDate = moment(e?.dateFilter?.startDate).format('YYYY-MM-DD');
    let endDate = moment(e?.dateFilter?.endDate).format('YYYY-MM-DD');
    let cityId = Object.keys(e?.zoneList || {})?.toString();
    let rmId = Object.keys(e?.rm || {})?.toString();
    let sourceId = Object.keys(e?.source || {})?.toString();
    getFunnelData({
      fromDateOverider: startDate,
      toDateOverrider: endDate,
      cityOverrider: cityId,
      sourceOverrider: sourceId,
      rmOverrider: rmId
    });
  };
  const commonUpperStyle = { maxHeight: '20px', maxWidth: '20px' };

  const rmImg = ({ className, style }) => (
    <SvgComponent
      img={rmICon}
      className={className}
      style={{ ...style, ...commonUpperStyle }}
    />
  );

  const dataList = [
    {
      img: CalendarTodayIcon,
      title: 'Data',
      name: 'date',
      component: DateFilter
    },
    {
      img: rmImg,
      title: 'RM',
      name: 'rm',
      component: RM
    },
    {
      img: DetailsIcon,
      title: 'Source',
      name: 'source',
      component: Source,
      dependencyData: { multiSelect: true }
    }
  ];

  const hrline =
    'border-t border-navy-200 float-right w-6/12 border-dashed -mt-3';

  const getTheGraph = (index, percentage) => {
    let borderRightColor = 'white';
    if (index >= 7 && index <= 12) {
      borderRightColor = '#fff3f4';
    }
    try {
      parseFloat(percentage);
    } catch {
      return '---';
    }
    if (percentage >= 15)
      return (
        <span className="w-full flex">
          <span
            className={`${graphLeft}`}
            style={{ borderTopColor: colors[index] }}
          ></span>
          <span
            className={`${graphCenter} w-full`}
            style={{ backgroundColor: colors[index] }}
          ></span>
          <span
            className={`${graphRight}`}
            style={{
              borderTopColor: colors[index],
              borderRightColor: borderRightColor
            }}
          ></span>
        </span>
      );
    else if (percentage >= 1.5 && percentage < 15)
      return (
        <span className="w-full flex">
          <span
            className={`${graphLeft_sm}`}
            style={{ borderTopColor: colors[index] }}
          ></span>
          <span
            className={`${graphCenter_sm} w-full`}
            style={{ backgroundColor: colors[index] }}
          ></span>
          <span
            className={`${graphRight_sm}`}
            style={{
              borderTopColor: colors[index],
              borderRightColor: borderRightColor
            }}
          ></span>
        </span>
      );
    else if (percentage >= 1 && percentage < 1.5)
      return (
        <span className="w-full flex">
          <span
            className={`${graphLeft_base}`}
            style={{ borderTopColor: colors[index] }}
          ></span>
          <span
            className={`${graphCenter_base} w-full`}
            style={{ backgroundColor: colors[index] }}
          ></span>
          <span
            className={`${graphRight_base}`}
            style={{
              borderTopColor: colors[index],
              borderRightColor: borderRightColor
            }}
          ></span>
        </span>
      );
    else
      return (
        <span
          className="w-full flex"
          style={{ minWidth: '8px', height: '20px' }}
        >
          <span
            className={`w-full`}
            style={{ backgroundColor: colors[index] }}
          ></span>
        </span>
      );
  };

  const getWidth = percentage => {
    try {
      if (parseFloat(percentage)) return `${percentage * maxVal}%`;
    } catch {
      return '0%';
    }
  };

  return (
    <React.Fragment>
      <Helmet title={`Funnel Report | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full  font-roboto text-sm font-normal m-0 p-0 ">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          <div className="w-full max-screen">
            <div className="w-full flex">
              <div className="flex items-center  flex-col xl:flex-row w-full">
                <div className="w-full text-black-400 text-md ml-4 font-bold mt-4 relative">
                  <span className="mr-1 cursor-pointer">Reports</span>
                  <FontAwesomeIcon
                    icon={faAngleDoubleRight}
                    className="mr-1 mt-1"
                  />
                  <span className="text-green-800">Funnel Report</span>
                </div>
              </div>
              <Header />
            </div>
            <div className="w-full  py-4 px-5 ">
              <div className="w-full xl:flex block xl:flex-wrap ">
                <div
                  className="cursor-pointer py-1 ml-4"
                  style={{ width: '150px' }}
                  onClick={() => setShowFilter(true)}
                >
                  <div className="border border-grey-2235 rounded flex py-2 px-4">
                    <p className="text-grey-2236 font-roboto font-normal text-sm">
                      Filter
                    </p>
                    <div className="table ml-auto ">
                      <FilterListIcon style={{ color: '#8a939e' }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full flex flex-wrap">
                {Object.keys(shoHtmlSelectedFileds || {}).map(
                  each => shoHtmlSelectedFileds[each]
                )}
              </div>
            </div>

            <div className="w-full py-2 px-5 flex">
              <div className="table bg-white border rounded border-navy-1000 border-solid py-3 px-5">
                <p className="font-roboto font-normal text-sm font-black-850 ">
                  Total Leads
                </p>
                <p className="font-roboto font-bold text-lg text-left text-black-500 ">
                  {numberFormat(funnelData?.totalLead) || 0}
                </p>
              </div>

              <div className="table bg-white border rounded border-navy-1000 border-solid py-3 px-5 ml-2">
                <p className="font-roboto font-normal text-sm font-black-850 ">
                  Total Spend
                </p>
                <p className="font-roboto font-bold text-lg text-left text-black-500 ">
                  ₹ {numberFormat(funnelData?.totalCost) || 0}
                </p>
              </div>
            </div>

            <div className="w-12/12  rounded-lg mx-auto px-5">
              <div className=" bg-white w-full overflow-auto px-3">
                {isInProgress ? (
                  <div className="w-full text-center py-20">
                    <div className="table mx-auto">
                      <NewSpinner />
                    </div>
                  </div>
                ) : (
                  <table
                    className="w-11/12 mt-5 "
                    style={{ maxWidth: '1600px' }}
                  >
                    <thead>
                      <tr>
                        <td colSpan="3"></td>
                        <td
                          className={`${tableHeader} font-medium font-roboto  text-center border border-navy-1000 border-solid px-2 py-2`}
                        >
                          Total
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>

                        <td
                          className={`${tableHeader} font-medium font-roboto   text-center border border-navy-1000 border-solid px-2 py-2`}
                        >
                          Percentage
                        </td>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td></td>
                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          Impressions (000’s)
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.totalImpressionPer)
                            }}
                          >
                            {getTheGraph(0, funnelData?.totalImpressionPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.totalImpression) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.totalImpressionPer || 0}%`}
                        </td>
                      </tr>

                      <tr>
                        <td></td>

                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          Click Through (CTR%)
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.totalClicksPer)
                            }}
                          >
                            {getTheGraph(1, funnelData?.totalClicksPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.totalClicks) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.totalClicksPer || 0}%`}
                        </td>
                      </tr>

                      <tr>
                        <td></td>

                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          OTP Sent
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.totalOTPSentPer)
                            }}
                          >
                            {getTheGraph(2, funnelData?.totalOTPSentPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.totalOTPSent) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.totalOTPSentPer || 0}%`}
                        </td>
                      </tr>

                      <tr>
                        <td></td>

                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          Leads
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.totalLeadPer)
                            }}
                          >
                            {getTheGraph(3, funnelData?.totalLeadPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.totalLead) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.totalLeadPer || 0}%`}
                        </td>
                      </tr>

                      <tr>
                        <td></td>

                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          RNR
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.rnrper)
                            }}
                          >
                            {getTheGraph(4, funnelData?.rnrper)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.rnr) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.rnrper || 0}%`}
                        </td>
                      </tr>

                      <tr>
                        <td></td>

                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          Call Back
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.callBackPer)
                            }}
                          >
                            {getTheGraph(5, funnelData?.callBackPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.callBack) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.callBackPer || 0}%`}
                        </td>
                      </tr>

                      <tr>
                        <td></td>

                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          Not Interest
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.notInterestedPer)
                            }}
                          >
                            {getTheGraph(6, funnelData?.notInterestedPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border-b-0 border-t border-l border-r border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.notInterested) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border-b-0 border-t border-l border-r text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.notInterestedPer || 0}%`}
                        </td>
                      </tr>

                      <tr className={`${rejectBg} ${showGpBorderTop}`}>
                        <td
                          rowSpan="5"
                          style={{ borderBottom: 'dashed 1px #f87aab' }}
                        >
                          <div className={`${rejectedGp} uppercase`}>
                            Rejected
                          </div>
                        </td>

                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          Unserviceable area
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.unservicableAreaPer)
                            }}
                          >
                            {getTheGraph(7, funnelData?.unservicableAreaPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} border-t-0 text-right border-l border-r border-b border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.unservicableArea) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border-r-0 border-t-0 border-l border-b text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.unservicableAreaPer || 0}%`}
                        </td>
                      </tr>

                      <tr className={rejectBg}>
                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          Low credit score
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.lowCreditScorePer)
                            }}
                          >
                            {getTheGraph(8, funnelData?.lowCreditScorePer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.lowCreditScore) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border-r-0 border-l border-b border-t text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.lowCreditScorePer || 0}%`}
                        </td>
                      </tr>

                      <tr className={rejectBg}>
                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          High ROI
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.highROIPer)
                            }}
                          >
                            {getTheGraph(9, funnelData?.highROIPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.highROI) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border-r-0 border-l border-b border-t text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.highROIPer || 0}%`}
                        </td>
                      </tr>

                      <tr className={rejectBg}>
                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          No Docs
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.noDocumentPer)
                            }}
                          >
                            {getTheGraph(10, funnelData?.noDocumentPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.noDocument) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border-r-0 border-l border-b border-t text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.noDocumentPer || 0}%`}
                        </td>
                      </tr>

                      <tr className={`${rejectBg} ${showGpBorderBottom}`}>
                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          Not Eligible
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.negativeProfilePer)
                            }}
                          >
                            {getTheGraph(12, funnelData?.negativeProfilePer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right  border-l border-b-0 border-t border-r border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.negativeProfile) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border-r-0 border-l border-b-0  border-t text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.negativeProfilePer || 0}%`}
                        </td>
                      </tr>

                      <tr>
                        <td></td>

                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          In Discussion
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.inDiscussionPer)
                            }}
                          >
                            {getTheGraph(13, funnelData?.inDiscussionPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border-t-0 border-l  border-b border-r border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.inDiscussion) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border-t-0 border-l  border-b border-r text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.inDiscussionPer || 0}%`}
                        </td>
                      </tr>

                      <tr>
                        <td></td>

                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          Docs Pending
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.documentPendingPer)
                            }}
                          >
                            {getTheGraph(14, funnelData?.documentPendingPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.documentPending) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.documentPendingPer || 0}%`}
                        </td>
                      </tr>

                      <tr>
                        <td></td>

                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          Login
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.loginPer)
                            }}
                          >
                            {getTheGraph(15, funnelData?.loginPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.login) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.loginPer || 0}%`}
                        </td>
                      </tr>

                      <tr>
                        <td></td>

                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          Sanction
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.sanctionedPer)
                            }}
                          >
                            {getTheGraph(16, funnelData?.sanctionedPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.sanctioned) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.sanctionedPer || 0}%`}
                        </td>
                      </tr>

                      <tr>
                        <td></td>

                        <td className={`${bodyCellPara} ${bodyCell} text-left`}>
                          Disbursement
                        </td>
                        <td
                          className={`${graphCell} w-full`}
                          style={{ minWidth: '350px' }}
                        >
                          <div
                            className="mx-auto table"
                            style={{
                              width: getWidth(funnelData?.disbursedPer)
                            }}
                          >
                            {getTheGraph(17, funnelData?.disbursedPer)}
                          </div>
                          <div className={hrline}></div>
                        </td>
                        <td
                          className={`${bodyCellTotal}  ${bodyCell} text-right border border-navy-1000 border-solid px-2 py-1`}
                        >
                          {numberFormat(funnelData?.disbursed) || '0'}
                        </td>
                        <td style={{ width: '10px' }} className="px-2"></td>
                        <td
                          className={`${bodyCellPercentage}  ${bodyCell} border text-right  border-navy-1000  border-solid  px-2 py-1`}
                        >
                          {`${funnelData?.disbursedPer || 0}%`}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <PopupFilter
        show={showFilter}
        setShow={setShowFilter}
        dataList={dataList}
        handleApply={appledFilters}
        handleToastBlock={e => setHtmlSelectedFileds(e)}
        masterFiltersData={masterFilters}
      />
    </React.Fragment>
  );
};

export default FunnelReport;
